import React, { createContext, useContext, useReducer, ReactNode } from 'react';

interface SignUpContextProps {
  formData: any;
  setFormData: (data: any) => void;
}

const SignUpContext = createContext<SignUpContextProps | undefined>(undefined);

const initialState = {
  demographics: {},
  userRole: {},
  creds: {},
  contactInfo: {},
  preferences: {},
};

function formReducer(state: any, action: any) {
  switch (action.type) {
    case 'SET_FORM_DATA':
      return { ...state, ...action.payload };
    default:
      return state;
  }
}

export const SignUpProvider: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  const [formData, dispatch] = useReducer(formReducer, initialState);

  const setFormData = (data: any) =>
    dispatch({ type: 'SET_FORM_DATA', payload: data });

  return (
    <SignUpContext.Provider value={{ formData, setFormData }}>
      {children}
    </SignUpContext.Provider>
  );
};

export const useSignUpContext = () => {
  const context = useContext(SignUpContext);
  if (!context) {
    throw new Error('useSignUpContext must be used within a SignUpProvider');
  }
  return context;
};
